import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlacesOfServiceCodesLookupService } from '@core/services/lookup';
import { PlaceOfServiceCrosswalkWrapperService } from '@core/services/service-wrappers/place-of-service-crosswalk-wrapper-service';
import { FieldSelectOption } from 'components';
import { PlaceOfServiceCrosswalkViewModel } from 'projects/data/src/lib/model/placeOfServiceCrosswalkViewModel';
import { asyncScheduler, combineLatest } from 'rxjs';
import { observeOn, take } from 'rxjs/operators';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UpdatePlaceOfServiceCrosswalkViewModel } from 'data';

@Component({
  standalone: false,
  selector: 'app-place-of-service-dialog',
  templateUrl: './place-of-service-dialog.component.html',
  styleUrls: ['./place-of-service-dialog.component.scss']
})
export class PlaceOfServiceDialogComponent implements OnInit {
  formGroup = new UntypedFormGroup({});
  formInitialized = false;
  saving = false;
  insuranceCarrierId;
  posDict = {};
  viewOnly = false;
  crosswalks: PlaceOfServiceCrosswalkViewModel[] = [];
  placeOfServiceOptions: FieldSelectOption[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<PlaceOfServiceDialogComponent>,
    private service: PlaceOfServiceCrosswalkWrapperService,
    private lookupService: PlacesOfServiceCodesLookupService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.insuranceCarrierId = data?.insuranceCarrierId;
    this.viewOnly = data?.viewOnly;
  }

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm() {
    combineLatest([
      this.service.apiV1PlaceOfServiceCrosswalkInsuranceCarrierInsurancecarrieridGet(this.insuranceCarrierId),
      this.lookupService.search('')
    ])
      .pipe(take(1))
      .subscribe(([pos, placeOfServiceOptions]) => {
        const formGroup = new UntypedFormGroup({});
        const posDict = {};

        placeOfServiceOptions.forEach((option) => {
          posDict[String(option.value)] = option.shortLabel ?? option.label?.split(' - ')[0] ?? '';
        });

        pos.forEach((p) => {
          //add the control to the underlying form group
          formGroup.addControl(
            'placeOfServiceCode' + p.originalPlaceOfServiceCode,
            new UntypedFormControl(p.replacementPlaceOfServiceCodeId ?? '')
          );
        });

        setTimeout(() => {
          this.crosswalks = pos;
          this.placeOfServiceOptions = placeOfServiceOptions;
          this.posDict = posDict;
          this.formGroup = formGroup;
          this.formInitialized = true;
          this.changeDetectorRef.detectChanges();
        }, 0);
      });
  }

  save() {
    if (this.formGroup.valid) {
      this.saving = true;
      const formData = this.formGroup.value;

      let crosswalks: UpdatePlaceOfServiceCrosswalkViewModel[] = [];
      const vals = Object.values(formData);
      Object.keys(formData).forEach((key, i) => {
        const val = vals[i].toString();
        crosswalks.push({
          originalPlaceOfServiceCode: key.replace('placeOfServiceCode', ''),
          replacementPlaceOfServiceCode: val === '' ? '' : this.posDict[val]
        });
      });

      this.service
        .apiV1PlaceOfServiceCrosswalkUpdateInsurancecarrieridPost(this.insuranceCarrierId, crosswalks)
        .pipe(take(1), observeOn(asyncScheduler))
        .subscribe(
          () => {
            this.dialogRef.close(true);
            this.notificationService.success('Place of Service Crosswalks updated');
          },
          (err) => {
            this.notificationService.error('Error updating Place of Service Crosswalks');
            this.saving = false;
            this.dialogRef.close(true);
          }
        );
    }
  }
}
